









import { RelatedTag } from '@empathy/search-types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class RelatedTags extends Vue {
  @Prop({ required: true })
  relatedTags: RelatedTag[];

  @Prop({ default: true })
  showSelectedValues: boolean;

  @Prop({ default: 'slide-top' })
  animation: 'slide-top' | 'slide-bottom' | 'slide-left' | 'slide-right' | string;

  get animationName() {
    return `ebx-related-tags__item--${ this.animation }`;
  }

  get sortedRelatedTags() {
    const unSelected = this.relatedTags.filter(relatedTag => !relatedTag.selected);
    return this.showSelectedValues
      ? this.relatedTags.filter(relatedTag => relatedTag.selected).concat(unSelected)
      : unSelected;
  }
}
